var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class EnvironmentsApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'environments';
    }
    getEnvironments(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const _params = Object.assign(Object.assign({}, params), { customerIds: Array.isArray(params === null || params === void 0 ? void 0 : params.customerIds)
                    ? params.customerIds.join(',')
                    : params === null || params === void 0 ? void 0 : params.customerIds });
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}`,
                params: _params,
            });
        });
    }
    getEnvironmentsV2(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            const _params = Object.assign(Object.assign({}, params), { customerId: Array.isArray(params === null || params === void 0 ? void 0 : params.customerId)
                    ? params.customerId.join(',')
                    : params === null || params === void 0 ? void 0 : params.customerId });
            return yield this.apiCall(Object.assign({ method: 'GET', route: `v2/${this.apiBasePath}`, params: _params }, options));
        });
    }
    getEnvironmentsV2Unscoped(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            const _params = Object.assign(Object.assign({}, params), { customerId: Array.isArray(params === null || params === void 0 ? void 0 : params.customerId)
                    ? params.customerId.join(',')
                    : params === null || params === void 0 ? void 0 : params.customerId });
            return yield this.apiCall(Object.assign({ method: 'GET', route: `v2/${this.apiBasePath}/unscoped`, params: _params }, options));
        });
    }
    startScanNewEnvs() {
        return __awaiter(this, arguments, void 0, function* (options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `v2/${this.apiBasePath}/scan-new-envs-init` }, options));
        });
    }
    getAggregatedServices() {
        return __awaiter(this, arguments, void 0, function* (options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/services` }, options));
        });
    }
    syncEnvironmentData(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/sync`, data: {
                    id,
                } }, options));
        });
    }
    createEnvironment(data_1) {
        return __awaiter(this, arguments, void 0, function* (data, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}`, data }, options));
        });
    }
    updateEnvironment(id_1, data_1) {
        return __awaiter(this, arguments, void 0, function* (id, data, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'PUT', route: `${this.apiBasePath}`, params: {
                    id: id,
                }, data }, options));
        });
    }
    deleteEnvironment(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, softDelete = true, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'DELETE', route: `${this.apiBasePath}`, params: {
                    id: id,
                    softDelete: softDelete,
                } }, options));
        });
    }
}
//# sourceMappingURL=index.js.map